import React, {Component} from 'react';
import Loading from "./../../components/loading";
import APIService from './../../modules/apiService';
import Subheader from "../../components/subheader";
import locales_es from "../../locales/es";
import {
	HREF_PAGE_ADD_MEDIC, HREF_PAGE_DASHBOARD, HREF_PAGE_HOME, hrefLogin, USER_TYPE_SECRETARY
} from "../../models/constants";
import Helpers from "../../modules/helpers";
import AuthService from "../../modules/authService";
import MedicsList from "../../components/medicsList";
import ConfigService from "../../modules/configService";
import Spinner from "../../components/spinner";

export default class MedicsPage extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			medics: null,
			apiMedics: null,
			clinicId: 0,
			reorder: false,
			initialOrder: [],
			currentOrder: [],
			specialties: [],
			selectedSpecialty: 'all',
		};
		
		this.api = new APIService();
		this.helpers = new Helpers();
		this.auth = new AuthService();
		this.configService = new ConfigService();
	}
	
	componentDidMount(cb) {
		this.configService.getLocalClinicData().then(clinic => {
			this.setState({
				clinicId: clinic.id,
				clinicName: clinic.name,
				clinicDescription: clinic.description,
				clinicWebUrl: clinic.web_url,
				clinicAddress: clinic.address,
				clinicLat: clinic.lat,
				clinicLng: clinic.lng,
			}, () => {
				if (this.state.clinicId) {
					const params = {clinic_id: this.state.clinicId};
					if (this.auth.getLocalUserType() === USER_TYPE_SECRETARY) {
						params.show_disabled = true;
					}
					this.api.getMedics(params)
						.then((res) => {
							const medics = res.data;
							
							const specialtiesMap = new Map();
							
							medics.forEach(m => {
								if (m.specialty_id && m.specialty_name && !specialtiesMap.has(m.specialty_id)) {
									specialtiesMap.set(m.specialty_id, {
										id: m.specialty_id,
										name: m.specialty_name
									});
								}
							});
							
							const specialties = Array.from(specialtiesMap.values());
							
							this.setState({
								medics, apiMedics: medics, initialOrder: medics.map(medic => medic.id), specialties
							});
						}).catch(err => {
						this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
						this.setState({
							medics: [], apiMedics: [], specialties: [],
						}, () => {
							cb && cb();
						});
					});
				} else {
					if (this.auth.isLoggedUser()) {
						window.location.href = HREF_PAGE_DASHBOARD
					} else {
						window.location.href = hrefLogin;
					}
				}
			});
		}).catch(err => {
			console.log(err);
		});
	}
	
	onSaveOrder = () => {
		this.api.putMedicClinicSort({
			medics_ids: this.state.currentOrder, clinic_id: this.state.clinicId
		}).then((res) => {
			this.props.showMainModal(locales_es.successModal.title, res.message);
			this.setState({reorder: false});
		}).catch(err => {
			this.props.showMainModal(locales_es.errorModal.title, this.helpers.getErrorMsg(err));
		});
	};
	
	onCancelReorder = () => {
		this.setState({medics: null}, () => {
			const reorderedMedics = [...this.state.apiMedics].sort((a, b) => this.state.initialOrder.indexOf(a.id) - this.state.initialOrder.indexOf(b.id));
			this.setState({medics: reorderedMedics, reorder: false});
		})
	};
	
	onSearchSubmit(ev) {
		if (ev && ev.preventDefault) {
			ev.preventDefault();
		}
		
		const input = document.getElementById('searchInput');
		const select = document.getElementById('specialtySelect');
		
		if (select) select.value = 'all';
		
		const query = input?.value || '';
		const regex = new RegExp(query, 'i');
		
		const {apiMedics} = this.state;
		let medics = [...apiMedics];
		
		medics = medics.filter(medic =>
			regex.test(medic.name) ||
			regex.test(medic.lastname) ||
			regex.test(medic.specialty_name)
		);
		
		this.setState({
			medics,
			selectedSpecialty: 'all'
		});
	}
	
	
	handleSpecialtyChange = (ev) => {
		const selectedSpecialty = ev.target.value;
		
		const input = document.getElementById('searchInput');
		if (input) input.value = '';
		
		const {apiMedics} = this.state;
		let medics = [...apiMedics];
		
		if (selectedSpecialty !== 'all') {
			medics = medics.filter(m => m.specialty_id == selectedSpecialty);
		}
		
		this.setState({
			selectedSpecialty,
			medics
		});
	};
	
	
	render() {
		
		const {medics, clinicId, clinicName, clinicDescription, clinicWebUrl, reorder} = this.state;
		
		const form = document.getElementById('searchForm');
		const input = form && form.children ? form.children[0] : {};
		const query = input.value;
		
		return (clinicId === 0 ? <Spinner/> : clinicId ? (<>
			<Subheader breadcrumbs={[{name: locales_es.allSpecialists, href: HREF_PAGE_HOME}]}/>
			<div className="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">
				<div className="kt-grid__item kt-grid__item--fluid kt-app__content">
					{reorder ? null :
						<div className="form-group row justify-content-center mt-3">
							<div className="col-12 col-lg-6">
								<select
									id="specialtySelect"
									className="form-control m-1 m-lg-0"
									onChange={this.handleSpecialtyChange}
									value={this.state.selectedSpecialty}
								>
									<option value="all">{locales_es.allSpecialties || 'Todas las especialidades'}</option>
									{this.state.specialties.map(spec => (
										<option key={spec.id} value={spec.id}>{spec.name}</option>
									))}
								</select>
							</div>
							<div className="col-12 col-lg-6">
								<form onSubmit={(e) => this.onSearchSubmit(e)} className="kt-input-icon kt-input-icon--right"
											id="searchForm">
									<input
										id="searchInput"
										className="form-control m-1 m-lg-0"
										type="search"
										onChange={(e) => this.onSearchSubmit(e)}
										placeholder={locales_es.searchByMedicsOrSpeciality}
									/>
									<span onClick={(e) => this.onSearchSubmit(e)}
												className="kt-input-icon__icon kt-input-icon__icon--right">
                      <span><i className="la la-search"/></span>
                    </span>
								</form>
							</div>
						</div>
					}
					{this.auth.getLocalUserType() === USER_TYPE_SECRETARY && !query && (
						<div className="row mb-3 justify-content-between">
							<div className="col-auto">
                <span
									className="d-flex btn btn-outline-secondary bg-white btn-pill btn-sm btn-bold btn-upper cursor-pointer"
									onClick={() => {
										if (reorder) {
											this.onCancelReorder();
										} else {
											this.setState({reorder: true});
										}
									}}
								>
                  <span className="kt-switch" style={{height: "35px"}}>
                    <label id="reorderSwitch">
                      <input
												type="checkbox"
												checked={reorder}
												readOnly
											/>
                      <span></span>
                    </label>
                  </span>
                  <label className="m-0 cursor-pointer">{locales_es.reorderList}</label>
                </span>
							</div>
							<div className="col-auto">
								{reorder ? (<button
									onClick={this.onSaveOrder}
									className="btn btn-warning btn-sm btn-bold btn-upper"
								>
									<i className="flaticon2-reord"/> {locales_es.saveOrderList}
								</button>) : (<a href={HREF_PAGE_ADD_MEDIC} className="btn btn-brand btn-sm btn-bold btn-upper">
									<i className="flaticon2-add-1"/> {locales_es.addMedic}
								</a>)}
							</div>
						</div>)}
					
					{medics == null ? (<Loading/>) : medics && medics.length ? (<MedicsList medics={medics} reorder={reorder}
																																									updateOrder={currentOrder => this.setState({currentOrder})}/>) : (
						<div className="tcenter">{locales_es.noMedicsAvailable} <br/><br/></div>)}
					{clinicId && clinicName && clinicDescription && (
						<div className="row">
							<div className="col">
								<div className="kt-portlet kt-portlet--height-fluid">
									<div className="kt-portlet__head">
										<div className="kt-portlet__head-label">
											<span className="kt-portlet__head-icon"><i className="flaticon-info"></i></span>
											<h3 className="kt-portlet__head-title">Acerca de {clinicName}</h3>
										</div>
										{clinicWebUrl && (
											<div className="kt-portlet__head-toolbar">
												<a href={clinicWebUrl} target="_blank" rel="noopener noreferrer">{locales_es.website}</a>
											</div>
										)}
									</div>
									<div className="kt-portlet__body">
										<div className="kt-portlet__content">
											<div className="mb-3" dangerouslySetInnerHTML={{
												__html: `${clinicDescription.replace(/\r?\n/g, '<br />')}`
											}} />

											{/* Dirección si existe */}
											{this.state.clinicAddress && (
												<p><strong>Dirección:</strong> {this.state.clinicAddress}</p>
											)}
											
											{/* Mapa estático si existe lat y lng */}
											{this.state.clinicLat && this.state.clinicLng && (
												<div className="text-center mt-3">
													<a
														href={`https://www.google.com/maps/search/?api=1&query=${this.state.clinicLat},${this.state.clinicLng}`}
														target="_blank"
														rel="noopener noreferrer"
													>
														<div style={{width: '100%', height: '100%'}}>
															<div dangerouslySetInnerHTML={{
																__html: `
										  					<iframe width="100%" height="100%" frameBorder="0" scrolling="no"
																	marginHeight="0" marginWidth="0"
																	src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=${this.state.clinicLat},${this.state.clinicLng}&hl=es&z=14&amp;output=embed"/>`
																}}
															/>
														</div>
													</a>
												</div>
											)}
										
										</div>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>) : (<div className="text-center m-5 p-5">{locales_es.loading}...</div>));
	}
}
